import PropTypes from "prop-types";
import React from "react";
import { Navbar, NavbarBrand } from "shards-react";

class SidebarMainNavbar extends React.Component {
  render() {
    const { hideLogoText } = this.props;
    return (
      <div className="main-navbar">
        <Navbar
          className="align-items-stretch bg-white flex-md-nowrap border-bottom p-0"
          type="light"
        >
          <NavbarBrand
            className="w-100 mr-0"
            href="/"
            style={{ lineHeight: "25px" }}
          >
            <div className="d-table m-auto">
              <img
                id="main-logo"
                className="d-inline-block mr-1 mb-1"
                style={{ maxWidth: "35px" }}
                src={require("../../../images/cow2.png")}
                alt=""
              />
              {!hideLogoText && (
                <span
                  className="d-none d-md-inline m-0 p-0"
                  style={{ fontSize: 20 }}
                >
                  Lonja Vacuno
                </span>
              )}
            </div>
          </NavbarBrand>
          {/* eslint-disable-next-line */}
          <a
            onClick={this.props.toggleSideBar}
            className="toggle-sidebar d-sm-inline d-md-none d-lg-none"
          >
            <i className="material-icons">&#xE5C4;</i>
          </a>
        </Navbar>
      </div>
    );
  }
}

SidebarMainNavbar.propTypes = {
  /**
   * Whether to hide the logo text, or not.
   */
  hideLogoText: PropTypes.bool,
};

SidebarMainNavbar.defaultProps = {
  hideLogoText: false,
};

export default SidebarMainNavbar;
